import Vue from 'vue';
import InputMask from './input-mask.component';

const InputProxy = Vue.extend(InputMask);
let masks = [];

export default {
  bind: (el, binding, vnode) => {
    let div = document.createElement('div'),
      inputWrapper = el.querySelector('.input-group__input');

    if (!inputWrapper) {
      return;
    }

    let input = inputWrapper.querySelector('input');
    inputWrapper.classList.add('input-mask');
    inputWrapper.appendChild(div);

    masks[vnode.componentInstance._uid] = new InputProxy({
      propsData: {
        maskType: binding.value.type,
        inputValue: vnode.componentInstance.value,
        prefix: binding.value.prefix,
        suffix: binding.value.suffix,
      },
    }).$mount(div);

    if (binding.arg === 'blur') {
      input.addEventListener('blur', () => {
        vnode.componentInstance.$emit('deconstructOnBlur');
      });
    }
  },
  componentUpdated: (el, binding, vnode) => {
    if (
      masks[vnode.componentInstance._uid] &&
      binding.value.value !== binding.oldValue.value
    ) {
      masks[vnode.componentInstance._uid].inputValue = binding.value.value;
    }
  },
  unbind: (el, binding) => {
    const input = el.querySelector('input');
    if (binding.arg === 'blur') {
      input.removeEventListener('input', () => {});
    }
  },
};
